module.exports = __webpack_public_path__ + "static/img/price-btn-box.c6a450c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/price-btn-box.png
// module id = iVz0
// module chunks = 1